import { IApplicationState } from '../../types/redux';

export const selectOpenVillageFilter = (state: IApplicationState): boolean => {
  return !!state.filters.savedFilters.withOpenVillage;
};
